import { toast } from 'sonner';

// Lien officiel Google Play de l'application
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.hypnosecle.twa';

// Image de partage (clé dorée) servie depuis /public
export const SHARE_IMAGE_URL = '/partage-hypnose-cle.png';

export const HASHTAGS = '#HypnoseClé #BienÊtre #DéveloppementPersonnel #PréparationMentale';

export const SHARE_TEXT = `Je te recommande Hypnose clé 🧘 Une superbe appli 100% gratuite : relaxation, hypnose, respiration guidée et préparation mentale.
${HASHTAGS}
📲 ${PLAY_STORE_URL}`;

async function getShareImageFile() {
  try {
    const res = await fetch(SHARE_IMAGE_URL);
    if (!res.ok) return null;
    const blob = await res.blob();
    return new File([blob], 'hypnose-cle.png', { type: blob.type || 'image/png' });
  } catch { return null; }
}

/**
 * Partage natif : image + texte + lien Play Store (WhatsApp, SMS, Facebook,
 * Instagram, Messenger… via la feuille de partage du téléphone).
 * Fallbacks : partage texte seul → copie dans le presse-papiers.
 */
export async function shareAppWithImage() {
  if (navigator.share) {
    const file = await getShareImageFile();
    if (file && navigator.canShare && navigator.canShare({ files: [file] })) {
      try {
        await navigator.share({ files: [file], title: 'Hypnose clé', text: SHARE_TEXT });
        return true;
      } catch (e) {
        if (e && e.name === 'AbortError') return true;
      }
    }
    try {
      await navigator.share({ title: 'Hypnose clé', text: SHARE_TEXT, url: PLAY_STORE_URL });
      return true;
    } catch (e) {
      if (e && e.name === 'AbortError') return true;
    }
  }
  try {
    await navigator.clipboard.writeText(SHARE_TEXT);
    toast.success('Message copié ! Partagez-le où vous voulez 💛');
    return true;
  } catch { return false; }
}

export const shareUrls = {
  whatsapp: `https://wa.me/?text=${encodeURIComponent(SHARE_TEXT)}`,
  facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(PLAY_STORE_URL)}&quote=${encodeURIComponent(SHARE_TEXT)}`,
  telegram: `https://t.me/share/url?url=${encodeURIComponent(PLAY_STORE_URL)}&text=${encodeURIComponent(SHARE_TEXT)}`,
  twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(SHARE_TEXT)}`,
  sms: `sms:?&body=${encodeURIComponent(SHARE_TEXT)}`,
  email: `mailto:?subject=${encodeURIComponent('Hypnose clé — Relaxation guidée')}&body=${encodeURIComponent(SHARE_TEXT)}`,
};
